<template>
  <div class="user_msg">
    <div class="header">
      <a class="logo" href="javascript:;"  @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <!-- <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt="">
      </a> -->
      <a class="quit" href="javascript:;" @click="loginOut">
        退出
      </a>
    </div>
    <div class="content">
      <div class="tit">我的消息</div>
      <div class="msg_box" v-for="(item,index) in list" :key="index">
        <div class="update_by">发布者：{{item.publishBy}}</div>
        <div class="msg_info">
          {{item.content}}
        </div>
        <div class="time">{{item.publishTime}}</div>
      </div>
      <div class="page" v-show="list&&list.length!=0">
        <div class="page_box">
          <div class="prev">
            <img v-if="page>1" src="../assets/img/prev.png" alt="" @click="prevPage()">
            <img v-if="page==1" src="../assets/img/prev_gray.png" alt="">
          </div>
          <div class="next">
            <img v-if="page<total" src="../assets/img/next.png" alt="" @click="nextPage()">
            <img v-if="page==total" src="../assets/img/next_gray.png" alt="">
          </div>
          <div class="page_msg">
            {{page}}/{{total}}页
          </div>
        </div>
      </div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
      list:[],
      size: 20,
      page:1,
      total:0 //分页总数
    }
  },
  mounted() {
    this.getListByPage();
  },
  methods: {
    loginOut(){
      window.sessionStorage.removeItem("accentToken")
      this.$router.push("login");
    },
    prevPage(){
      window.scrollTo(0,0);
      if(this.page>1){
        this.page = this.page - 1;
        this.getListByPage();
      } else{
        this.page = 1;
      }
    },
    nextPage(){
      window.scrollTo(0,0);
      if(this.page<this.total){
        this.page = this.page + 1;
        this.getListByPage();
      } else{
        this.page = this.total;
      }
    },
    getListByPage() {
      this.$axios.post('/api/web/phone/personal-center/notification-list', {
          page:this.page,
          size:this.size
        }).then((res)=>{
        this.total = res.data.pages;
        this.list = res.data.list;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .user_msg {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .pl-75{
    padding-left: 75px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 18px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
    .quit{
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 18px;
      color: #fff;
      font-size: 16px;
    }
  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 54px;
    text-align: left;
    .tit{
      height:22px;
      font-size:16px;
      color:#333333;
      line-height:22px;
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .msg_box{
      margin-top: 15px;
      border-bottom: 1px solid #E0E0E0;
    }
    .update_by{
      margin-bottom: 10px;
      font-size:14px;
      color:#333333;
      line-height:20px;
    }
    .msg_info{
      font-size:13px;
      color:#666666;
      line-height:18px;
      margin-bottom: 10px;
    }
    .time{
      height:18px;
      font-size:13px;
      color:#666666;
      line-height:18px;
      margin-bottom: 10px;
    }
    .page{
      text-align: center;
      padding: 25px;
      .page_box{
        position: relative;
        margin: 0 auto;
        width: 112px;
        color: #666666;
        font-size: 14px;
        .prev{
          position: absolute;
          left: 0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        .next{
          position: absolute;
          right:0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        img{
          width: 16px;
          height: 16px;
          content:normal !important;
        }
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user-msg.vue